import { useEffect } from "react";

const setMetaTag = (name, content) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const useDocumentMeta = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMetaTag("description", description);
  }, [title, description]);
};

export default useDocumentMeta;
